"use client";
import { usePathname } from "@/navigation";
import Footer from "./page";

export default function ConditionalFooter() {
	const pathname = usePathname();
	
	// 如果是首页，不渲染 Footer（因为已经在 FullPageScroll 中）
	const isHomePage = pathname === "/" || pathname.match(/^\/[a-z]{2}$/) || pathname.match(/^\/[a-z]{2}\/?$/);
	
	if (isHomePage) {
		return null;
	}
	
	return <Footer />;
}

